﻿<template>
	<div class="row user-select-none">
		<div class="col-12">
			<div class="div-container">
				<div class="header">
					<div class="ratings">
						<span>{{this.nrRatings}} {{this.name}}</span>
					</div>
					<div class="stars" :title="titleNrStars">
						<img v-for="(starImgUrl, i) in getStarImageUrls(rating)" :src="starImgUrl" width="40" height="40" />
					</div>
				</div>
				<div class="body mt-2">
					<table class="rating-indicators">
						<tr v-for="(rating, i) in [5, 4, 3, 2, 1]" class="rating-indicator" :title="getTitleRatingIndicator(rating)">
							<td class="td1"><span>{{getRatingLabel(rating)}}</span></td>
							<td class="td2">
								<div class="percentage-container">
									<div class="percentage-bar" :style="{width: getRatingPercentage2(rating)}"></div>
								</div>
							</td>
							<td class="td3"><span>{{zeroDecimals(getRatingPercentage(rating))}}%</span></td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>




<script>
	import { getStarImageUrls } from '@/js/shared/utils/common';
	import { toFixedNumber } from '@/js/shared/utils';
	export default {
		data: () => ({
			minStars: 1,
			maxStars: 5
		}),
		props: {
			ratingCount1: { type: Number, required: false, default: () => 0 },
			ratingCount2: { type: Number, required: false, default: () => 0 },
			ratingCount3: { type: Number, required: false, default: () => 0 },
			ratingCount4: { type: Number, required: false, default: () => 0 },
			ratingCount5: { type: Number, required: false, default: () => 0 },
			singularName: { type: String, required: false, default: () => 'Rating' },
			pluralName: { type: String, required: false, default: () => 'Ratings' }
		},
		methods: {
			getStarImageUrls(rating) {
				return getStarImageUrls(rating);
			},
			getRatingLabel(rating) {
				var name = (rating == 1)	? 'star' : 'stars';
				return `${rating} ${name}`;
			},
			getRatingPercentage(rating) {
				switch (rating) {
					case 5 : return this.percentage5;
					case 4 : return this.percentage4;
					case 3 : return this.percentage3;
					case 2 : return this.percentage2;
					case 1 : return this.percentage1;
					default : return '?';
				}
			},
			getRatingPercentage2(rating) {
				var pct = this.getRatingPercentage(rating);
				return `${pct}%`;
			},
			getRatingPercentage3(rating) {
				return 100;
			},
			getTitleRatingIndicator(rating) {
				var percentage = 0;

				switch (rating) {
					case 5 : percentage = this.percentage5; break;
					case 4 : percentage = this.percentage4; break;
					case 3 : percentage = this.percentage3; break;
					case 2 : percentage = this.percentage2; break;
					case 1 : percentage = this.percentage1; break;
				}

				return `${toFixedNumber(percentage, 0)}% of ratings has ${rating} stars`;
			},
			zeroDecimals(n) {
				return toFixedNumber(n, 0);
			}
		},
		computed: {
			nrRatings() {
				return (this.ratingCount1 + this.ratingCount2 + this.ratingCount3 + this.ratingCount4 + this.ratingCount5);
			},
			rating() {
				var sum = (this.ratingCount1 * 1) + (this.ratingCount2 * 2) + (this.ratingCount3 * 3) + (this.ratingCount4 * 4) + (this.ratingCount5 * 5);
				return (sum / this.nrRatings);
			},
			percentage1() {
				return ((this.ratingCount1 / this.nrRatings) * 100);
			},
			percentage2() {
				return ((this.ratingCount2 / this.nrRatings) * 100);
			},
			percentage3() {
				return ((this.ratingCount3 / this.nrRatings) * 100);
			},
			percentage4() {
				return ((this.ratingCount4 / this.nrRatings) * 100);
			},
			percentage5() {
				return ((this.ratingCount5 / this.nrRatings) * 100);
			},
			name() {
				return (this.nrRatings == 1) ? this.singularName : this.pluralName;
			},
			titleNrStars() {
				return `${toFixedNumber(this.rating, 1)} Stars`;
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	.div-container {
		border:1px solid #e2e9ee;
		border-radius:10px;
		padding:5px 10px 10px 10px;
		/*max-width:500px*/;
	}

	.header {
		display:flex;
		flex-direction:column;
		align-items:center;
		justify-content:center;
	}

	.stars {
		cursor:help;
	}

	.ratings span {
		font-size:1.75em;
	}

	.stars {

	}

	.stars img {
		width:40px;
		height:40px;
	}

	.rating-indicators {
		width:100%;
	}

	.rating-indicator {
		display:flex;
		align-items:center;
		justify-content:center;
		cursor:help;
	}

	.percentage-container {
		position:relative;
		background:rgba(252,200,117,.25);
		width:100%;
		height:15px;
		border-radius:3px;
		flex-grow:1;
		margin:0px 0px;
	}

	.percentage-bar {
		position:absolute;
		background:#fcc875;
		left:0px;
		height:100%;
		border-radius:3px;
	}

	.star-count-label {
		flex-grow:0;
	}

	.td1 {
		width:20%;
	}

	.td2 {
		width:65%;
	}

	.td3 {
		width:15%;
		text-align:right;
	}

	.td span {
		white-space:nowrap;
	}

	@media screen and (min-width:340px) {
		.td1 { width:18%; }
		.td2 { width:66%; }
		.td3 { width:16%; }
	}

	@media screen and (min-width:380px) {
		.td1 { width:16%; }
		.td2 { width:70%; }
		.td3 { width:14%; }
	}

	@media screen and (min-width:420px) {
		.td1 { width:14%; }
		.td2 { width:74%; }
		.td3 { width:12%; }
	}

	@media screen and (min-width:460px) {
		.td1 { width:12%; }
		.td2 { width:78%; }
		.td3 { width:10%; }
	}

	@media screen and (min-width:500px) {
		.div-container {
			padding:10px 20px;
		}

		.header {
			flex-direction:row;
		}

		.stars {
			margin-left:10px;
		}
	}

</style>
